const template = require('./progress.template');	
require('./progress.styles');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbProgress
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbProgress` is a progress loader ui
 *
 * @param {string=} message The message to show below the progress indicator
 *
 * @param {bool} backdrop The expression that determines if the backdrop is displayed
 *
 * @param {bool} show The expression that determines whether the ui is visible
 *
 * @param {element=} target The element that the progress indicator should be centered on
 *
 * @usage
 *
 * <sb-progress message="text to show" backdrop="true" show="true === true"/>
 */
export function ProgressDirective() {		
	return {
		restrict: 'E',
		controller: ProgressController,
		controllerAs: 'ProgressCtlr',
		bindToController: true,
		template,
		scope: {
			message: '=',
			backdrop: '=',
			show: '=',
			target: '='
		},
		link: function (scope, element) {
			scope.$watch('ProgressCtlr.target', function (newVal) {
				if (!newVal) {
					scope.ProgressCtlr.marginLeft = null;
					return;
				}
				var rects;
				if (newVal.length) {
					rects = newVal[0].getClientRects();
				}
				else {
					rects = newVal.getClientRects();
				}

				scope.ProgressCtlr.marginLeft = ((rects[0].left / 2) - 100) + 'px';

			});
		}
	};
}

function ProgressController() {
}


// WEBPACK FOOTER //
// ./src/sharebase/components/progress/progress.ts